"use strict";
/*
* Created on 11.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Order suggested converter.
 *
 * @author ZSr
 */


var SupplierOrderSuggestedConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierOrderSuggestedConverter, _DataObjectConverter_);

  function SupplierOrderSuggestedConverter() {
    _classCallCheck(this, SupplierOrderSuggestedConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierOrderSuggestedConverter).apply(this, arguments));
  }

  return SupplierOrderSuggestedConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierOrderSuggestedConverter = SupplierOrderSuggestedConverter;